YP.TicketingSettingManager = function() {
    return {
        init: function(){
            this.displayOrHideVatNumberField();
        },

        displayOrHideVatNumberField: function(){
            var vatNumberDiv = $('.vat_number_div');
            $('#tva_tva_rate').on('change', function() {
                if(this.value == 0) {
                    vatNumberDiv.hide();
                } else {
                    vatNumberDiv.show();
                }
            });
        }
    }
};

window.addEventListener("load", function(){
    YP.TicketingSettingManager().init();
});
